import { useState } from "react";
import PropTypes from 'prop-types';
import Image from 'next/image';
import { addLikeToReview } from "aster-foundation/core/epharmacy/RatingsAndReviews/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import StarRating from "@common/Component/StarRating/StarRating";
import { IC_LIKED_EMPTY, IC_LIKED_FILLED } from '../../../../public/images';
import logger from "@common/Utility/logger";
import { convertDateMonthToCommaFormat } from "@common/Utility/date-utils";
import { capitalizeFirstLetter, errorHandlingEpharmacy, getReferralPageForGA } from "@common/Utility/common-utils";

const DisplayProductReviews = (props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { data, key } = props;
  const { ratingReview, comments, author, likesCount, reviewDate, id, anonymous, currentUserlikeFlag } = data;

  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);

  const [isCollapse, setIsCollapse] = useState(true);
  const [isLiked, setIsLiked] = useState(currentUserlikeFlag);
  const [totalLikes, setTotalLikes] = useState(likesCount);
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;

  const onLikeReview = () => {
    if (userLogin) {
      dispatch(addLikeToReview({
        params: { id, isLiked: !isLiked, userPatientId: userLogin?.id },
        onSuccess: () => {
          setIsLiked((liked) => !liked);
          const likes = isLiked ? totalLikes - 1 : totalLikes + 1;
          setTotalLikes(likes);
        },
        onFailure: (error) => { 
          logger.error('Add Like to review', error);
          errorHandlingEpharmacy(error, true, screenName, pageType);
         }
      }));
    }
  };

  const scrollToReviewBottom = () => {
    if (!isCollapse) {
      const element = document?.getElementById('ratingsReviewRef');
      const headerOffset = 100;
      const elementPosition = element?.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const userName = anonymous ? 'Anonymous' : `${author?.nickname || ''}`;

  return (
    <div className="commentItem" key={key}>
      <div className="ratingAndLikes">
        <div id="ratingsReviewRef">
          <div className="reviewerName">{capitalizeFirstLetter(userName)}</div>
          <StarRating rating={ratingReview?.ratingValue} size="16" customClass="commentRatings" />
        </div>
        <div className={`like ${isLiked && 'liked'}`}>
          <span className={userLogin && "likedIconFilled"}>
            <Image
              src={isLiked ? IC_LIKED_FILLED.src : IC_LIKED_EMPTY.src}
              height={24}
              width={24}
              alt="like Icon"
              onClick={() => onLikeReview()}
            />
          </span>
          {totalLikes > 0 && <span className="likeCounts">{totalLikes}</span>}
        </div>
      </div>
      <div className="review">{capitalizeFirstLetter(comments.title)}</div>
      <div className={`reviewDesc ${isCollapse && 'short'}`}>{capitalizeFirstLetter(comments.description)}</div>
      {comments.description.length >= 200 && (
        <a className="readLink" onClick={() => {
          setIsCollapse((collapse) => !collapse);
          scrollToReviewBottom();
        }}>
          {isCollapse ? 'Read More' : 'Read Less'}
        </a>
      )}
      <div className="reviewDate">Reviewed on {convertDateMonthToCommaFormat(reviewDate)}</div>
    </div>
  );
};

DisplayProductReviews.propTypes = {
  data: PropTypes.object,
  key: PropTypes.number,
};

DisplayProductReviews.defaultProps = {
  data: {},
  key: 0,
};

export default DisplayProductReviews;